import React, { useState } from "react";
import Slide from "../HomepageSlider/Slide";

const Articles = ({ articles, totalPages }) => {
  const [content, setContent] = useState(articles);
  const [page, setPage] = useState(1);

  const url = window.location.pathname;
  const axios = require('axios');
  axios.defaults.headers.common['Accept'] = 'application/json';

  const handleSubmit = e => {
    e.preventDefault();

    let nextPage = page + 1;

    axios.get(url, {
      params: {
        page: nextPage
      }
    }, { headers: {'Content-Type': 'text/javascript'} })
    .then(function (response) {
      setContent([...content,...response.data]);
      setPage(nextPage);
    })
    .catch(function (error) {
      console.log(error);
    });
  };

  return (
    <div>
      <div className="blog-author__articles">
        { content.map((item, index) =>
          <div className="blog-author__article-card" key={index}>
            <Slide
              title={item.title}
              tag={item.tag}
              image={item.image}
              link={item.link}
            />
          </div>
        )}
      </div>
      <div className="promos-container__more">
        { page < totalPages  &&
          <a className="button button_large" onClick={handleSubmit} rel="next">Загрузить еще</a>
        }
      </div>
    </div>
  )
}

export default Articles;
